module.exports = {"myCards":"paymentMethodTokens","newCard":"newPaymentMethod"}